module.exports = __webpack_public_path__ + "static/img/HappyB2.e08f8181.png";